/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsEDRMachineCriticalIssuesCount
 */
export interface JumboStructsEDRMachineCriticalIssuesCount {
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineCriticalIssuesCount
     */
    antivirusDisabledCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineCriticalIssuesCount
     */
    tamperProtectionDisabledCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineCriticalIssuesCount
     */
    unhealthyEDRStatusCount?: number;
}

/**
 * Check if a given object implements the JumboStructsEDRMachineCriticalIssuesCount interface.
 */
export function instanceOfJumboStructsEDRMachineCriticalIssuesCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsEDRMachineCriticalIssuesCountFromJSON(json: any): JumboStructsEDRMachineCriticalIssuesCount {
    return JumboStructsEDRMachineCriticalIssuesCountFromJSONTyped(json, false);
}

export function JumboStructsEDRMachineCriticalIssuesCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsEDRMachineCriticalIssuesCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'antivirusDisabledCount': !exists(json, 'antivirusDisabledCount') ? undefined : json['antivirusDisabledCount'],
        'tamperProtectionDisabledCount': !exists(json, 'tamperProtectionDisabledCount') ? undefined : json['tamperProtectionDisabledCount'],
        'unhealthyEDRStatusCount': !exists(json, 'unhealthyEDRStatusCount') ? undefined : json['unhealthyEDRStatusCount'],
    };
}

export function JumboStructsEDRMachineCriticalIssuesCountToJSON(value?: JumboStructsEDRMachineCriticalIssuesCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'antivirusDisabledCount': value.antivirusDisabledCount,
        'tamperProtectionDisabledCount': value.tamperProtectionDisabledCount,
        'unhealthyEDRStatusCount': value.unhealthyEDRStatusCount,
    };
}

